import { useEffect, useRef, useState } from "react";
import { MapPin, X } from "lucide-react";
import * as XLSX from "xlsx";
import { useStateValue } from "../../context/StateProvider";
import { deleteApp, initializeApp } from "firebase/app";
import { firebaseConfig, firestored } from "../../firebase/firebaseConfig";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signOut,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";

const BulkUploadUser = ({ onClose, onSubmit }) => {
  const [{ user }, dispatch] = useStateValue();

  const [Data, setData] = useState([]);

  const [loading, setloading] = useState(false);

  function formatPhone(value) {
    const digits = value.replace(/\D/g, "").slice(0, 10);

    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;

    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      // Read first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Convert to JSON
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      let newdata = [];
      console.log("THis is all the data " + JSON.stringify(jsonData));

      jsonData.forEach((item) => {
        let datset = {
          // id: "",
          firstname: item?.AgentFirst ? item?.AgentFirst : "",
          lastname: item?.AgentLast ? item?.AgentLast : "",
          email: item?.AgentEmail ? item?.AgentEmail : "",
          phonenumber: item?.Phone ? formatPhone(item?.Phone) : "",
          role:
            item?.Role == "Team Lead"
              ? "Admin"
              : item?.Role == "Client Care"
                ? "Supervisor"
                : "Employee",
          profilepicture: "",
          isShowStats: false,
          createdAt: Date.now(),
          createdBy: user?.id,
        };
        newdata.push(datset);
      });
      setData(newdata);
    };
    reader.readAsBinaryString(file);
  };

  function heading(title, required) {
    return (
      <div className="flex flex-row mb-1">
        <label className="block font-medium text-sm ">{title}</label>
        {required && (
          <label className="block font-medium text-sm text-red-700 ml-[2px] ">
            *
          </label>
        )}
      </div>
    );
  }

  function stats(title, description) {
    return (
      <div className="lg:w-[32%] flex  flex-col items-center mb-4">
        <p className="text-black/50 text-center font-medium">{title}</p>
        <p className=" text-sm font-semibold text-black">
          {description || "-"}
        </p>
      </div>
    );
  }

  function dealinfo(title, description) {
    return (
      <div className="flex flex-col items-center">
        <span className="text-xs text-gray-500 mb-1">{title}</span>
        <span className="font-normal text-slate-900">{description}</span>
      </div>
    );
  }

  function userCard(userdetails) {
    return (
      <div className="bg-white rounded-2xl shadow-sm p-6 hover:shadow-lg hover:-translate-y-1 transition cursor-pointer border border-gray-200">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 border-y border-gray-200 py-4 mb-4">
          {dealinfo(
            "Full Name",
            userdetails.firstname + " " + userdetails.lastname,
          )}

          {dealinfo("Email", userdetails.email)}
          {dealinfo("Phone Number", userdetails.phonenumber)}
          {dealinfo(
            "Role",
            userdetails.role == "Admin"
              ? "Team Lead"
              : userdetails.role == "Supervisor"
                ? "Client Care"
                : "Employee",
          )}
        </div>
      </div>
    );
  }

  async function uploaduserdata() {
    setloading(true);
    const secondaryApp = initializeApp(firebaseConfig, "Secondary");
    const secondaryAuth = getAuth(secondaryApp);
    try {
      // ✅ Create a completely new secondary auth instance

      for (const key in Data) {
        try {
          await createUserWithEmailAndPassword(
            secondaryAuth,
            Data[key].email,
            "abcd1234",
          ).then(async (userCredential) => {
            const user = userCredential.user;
            let dataset = {
              id: user?.uid,
              ...Data[key],
            };
            await setDoc(doc(firestored, "users", dataset.id), dataset);
            toast.success(
              dataset.firstname +
                " " +
                dataset.lastname +
                " created successfully!",
            );
          });
        } catch (error) {
          console.log("Error creating user:", error);
          toast.error(error.message);
        } finally {
        }
      }
    } catch (error) {
      console.log("global error creating user:", error);
      toast.error(error.message);
      setloading(false);
    } finally {
      await signOut(secondaryAuth);

      await deleteApp(secondaryApp);
      setData([]);
      setloading(false);
      onClose();
    }
  }
  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] lg:w-[70%] h-[85%]  bg-white relative">
          {loading && (
            <div className="position absolute h-full w-full bg-black/50 flex justify-center items-center">
              <div role="status" className="">
                <svg
                  aria-hidden="true"
                  class="size-10 text-gray-200 animate-spin dark:text-white fill-[#1E293B]"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-black/10 h-[12%] bg-[#1E293B] text-white ">
            <div>
              <h2 className="text-xl font-semibold">Bulk User Registration</h2>
            </div>
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          {/* {Data.length > 0 && (
            <div className="flex items-center justify-between py-2 px-[14px]">
              <div>
                <h2 className="text-lg font-semibold text-indigo-600">
                  {"Users Found - " + Data.length}
                </h2>
              </div>
            </div>
          )} */}
          <div className="w-full  h-[78%]  overflow-y-auto form-scrollbar py-2 ">
            {Data.length > 0 ? (
              <div className="grid gap-6">
                {Data.map((item, i) => {
                  return (
                    <div className="w-full px-[10px]">{userCard(item)}</div>
                  );
                })}
              </div>
            ) : (
              <div className="w-full px-[20px] py-[20px]">
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  onChange={handleFileUpload}
                />
              </div>
            )}
          </div>
          {Data.length > 0 && (
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 h-[10%] px-[10px]">
              <div className="flex flex-wrap gap-2  items-center  justify-end w-full">
                <button
                  onClick={() => {
                    setData([]);
                  }}
                  className="px-6 py-2 border border-gray-200 rounded-md text-sm hover:bg-red-500 hover:text-white  transition"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    uploaduserdata();
                  }}
                  className="ml-[5px] px-6 py-2 border border-gray-200 rounded-md text-sm hover:bg-[#1E293B] hover:text-white hover:border-[#1E293B] transition"
                >
                  Upload
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BulkUploadUser;
